module.exports = __webpack_public_path__ + "static/media/James B. Weaver - 1892.61ac8723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James B. Weaver - 1892.jpg
// module id = 499
// module chunks = 0